import React from 'react';

import {
  BaseModalFooter,
  BaseModal,
  BaseModalProps,
} from 'components/wrappers/BaseModal';
import {
  InternationalProfileFormValues,
  mapInternationProfileToRequest,
} from './InternationalProfileForm/mapUtils';
import BaseAlert from 'components/wrappers/BaseAlert';
import { ApiErrorMessage } from 'constants/ErrorMessages';
import SubmitButton from 'components/formik/SubmitButton';
import {
  FullBOUserResponseModel,
  ProfileTypeEnum,
} from 'api/backofficeApiClient';
import InternationalProfileForm from './InternationalProfileForm';
import { saveInternationalGeneralInfo } from 'redux/reducers/accountSlice';
import { saveRecruiterInternationalGeneralInfo } from 'redux/reducers/recruiterSlice';
import { useAppDispatch } from 'hooks/useAppDispatch';

type Props = {
  formRef: any;
  isAdmin?: boolean;
  onSuccess: () => Promise<void>;
  modalProps: BaseModalProps;
  profileInfo?: FullBOUserResponseModel;
};

export default function InternationalProfileModal(props: Props) {
  const { formRef, isAdmin, modalProps, profileInfo, onSuccess } = props;
  const dispatch = useAppDispatch();

  const handleSubmit = async (values: InternationalProfileFormValues) => {
    const data = mapInternationProfileToRequest(values, profileInfo);

    const correctAction = isAdmin
      ? saveRecruiterInternationalGeneralInfo
      : saveInternationalGeneralInfo;

    const result = await dispatch(correctAction(data));

    if (correctAction.fulfilled.match(result)) {
      await onSuccess();

      BaseAlert.success('Profile changes saved.');
    } else {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }
  };

  return (
    <BaseModal {...modalProps}>
      <InternationalProfileForm
        formRef={formRef}
        onSubmit={handleSubmit}
        profileInfo={profileInfo}
        profileType={profileInfo?.profileType as ProfileTypeEnum}
        formFooter={
          <BaseModalFooter>
            <SubmitButton>Save</SubmitButton>
          </BaseModalFooter>
        }
      />
    </BaseModal>
  );
}
